/* loaded by smart-asset */
export default require("./assets/white-tote.i.svg")